import i18n from '../../utils/i18n'

export const WeightUnitBodyTemplate = (unit?: string) => {
  if (!unit) return null

  return (
    <>
      {i18n.t(
        `masterDataManagement.packagingData.table.columns.tareWeightUnit.options.${unit}`,
      )}
    </>
  )
}
